import React, { useState } from "react";
import { HStack, Icon, IconButton, Tooltip } from "@chakra-ui/react";
import CreateLoginLink from "./CreateLoginLink";
import { RiMailCheckLine, RiMailFill, RiUserFill } from "react-icons/ri";
import { User } from "types/user";
import UserForm from "./UserForm";
import { useToast } from "hooks";
import { sendLoginEmail } from "api/webservice/users";
import { useModal } from "context/modal";
import { Callback } from "types";

interface Props {
  user: User;
  saveUser: Callback;
  deleteUser: Callback;
}

const UserActions: React.FC<Props> = ({
  user,
  saveUser,
  deleteUser
}: Props) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const toast = useToast();
  const { openModal, closeModal, setTitle, setContent } = useModal()!;

  const handleSave = (user: any): void => {
    closeModal();
    saveUser(user);
  };

  const openEditModal = () => {
    setTitle("Edit User Profile");
    setContent(
      <UserForm saveUser={handleSave} deleteUser={deleteUser} user={user} />
    );
    openModal();
  };

  const resendLoginEmail = () => {
    if (success || loading) return;
    setLoading(true);
    sendLoginEmail(user.id)
      .then(() => {
        setSuccess(true);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        toast({
          title: "Error sending email",
          description: error.response.data.response,
          status: "error"
        });
      });
  };

  return (
    <HStack spacing="3" justifyContent="flex-end">
      <Tooltip label="Edit Profile" fontSize="md">
        <IconButton
          size="lg"
          isRound
          aria-label="Edit profile"
          icon={<Icon as={RiUserFill} />}
          onClick={openEditModal}
        />
      </Tooltip>
      <Tooltip label="Send Login Email" fontSize="md">
        <IconButton
          size="lg"
          isRound
          aria-label="Send login email"
          icon={
            success ? <Icon as={RiMailCheckLine} /> : <Icon as={RiMailFill} />
          }
          onClick={resendLoginEmail}
          isLoading={loading}
        />
      </Tooltip>
    </HStack>
  );
};

export default UserActions;
